<div class="service-item">
  <div class="card-label {{labelClass}}">
    <span>{{ labelText }}</span>
  </div>
  <span class="header-text" >{{ cardData.title }}</span>

  <div class="card-fields" *ngIf="cardData.location!=null && cardData.location!=''">
    <span class="bold">{{layoutData.locationTitle}}</span> {{ cardData.location }}
  </div>
  <div class="card-fields" *ngIf="cardData.location == null || cardData.location==''">
    <span class="bold">{{layoutData.internalLocationText}}</span>
  </div>

  <div class="card-fields" *ngIf="cardData.industry">
    <span class="bold">{{layoutData.industryTitle}}</span> {{ cardData.industry }}
  </div>
  <div class="card-fields" *ngIf="cardData.degreesDisplayText">
    <span class="bold">{{layoutData.degreesTitle}}</span> {{ cardData.degreesDisplayText }}
  </div>
  <div class="card-publish-date card-fields" *ngIf="cardData.updateDateDisplayText">
    <span class="bold">{{layoutData.updateDateTitle}}</span> {{ cardData.updateDateDisplayText }}
  </div>
  
  <a [href]="cardData.link" target="_blank" class="link card-link" *ngIf="cardData.link!=null && cardData.link!=''">
    <div class="link-text">{{ layoutData.tellMeMoreAboutItLinkTitle }}</div>
    <div class="link-arrow">
      <img
        src="/Content/Images/icons/arrow-down.svg"
        width="18"
        height="12"
      />
    </div>
  </a>
</div>